import React from "react";
import { Stack, Tooltip, Typography } from "@mui/material";
import { REDUCED_CO2_MEASURE_UNIT, REDUCED_CO2_PLOT_MEASURE_UNIT } from "../../Constants/Calculations";
import { useAppSelector } from "../../Redux/Hooks/Hooks";
import { useTranslation } from "react-i18next";
import CFPTabelSelectors from "../../Redux/States/CFPTable/selectors";

type BoxItem = {
  logo: string;
  label: string;
  value: string;
  isLastItem?: boolean;
};

function SmallerBox(props: BoxItem) {
  return (
    <Stack direction={"row"} gap={1} sx={{ borderLeft: props.isLastItem ? "1px solid #7C7C7C" : "", paddingLeft: props.isLastItem ? 5 : 0 }}>
      {props.logo && <img src={props.logo} alt="logo" />}

      <Stack direction={"column"}>
        <span style={{ color: "#00833E", fontSize: 14, fontWeight: "bold" }}>{props.label}</span>
        <span style={{ fontSize: 35 }}>{props.value}</span>
      </Stack>
    </Stack>
  );
}

export function FmCarbonBanner() {
  const metricMethod = useAppSelector((state) => Number.parseInt(state.general.activeMetricMethod || "-1"));
  const plotSize = useAppSelector((state) => state.agriSolution.plotSize);
  const expectedYield = useAppSelector((state) => state.agriSolution.cropsState.expectedYield);
  const reducedCo2 = useAppSelector(CFPTabelSelectors.reducedCo2);
  const { t } = useTranslation();

  const items: BoxItem[] = [
    {
      logo: "/multi-match/assets/icons/apple_logo.svg",
      label: `${t("cfpTable.reducedCo2")} ${REDUCED_CO2_MEASURE_UNIT[metricMethod - 1]}`,
      value: `${Number(reducedCo2 * expectedYield!).toFixed(2)} ${REDUCED_CO2_PLOT_MEASURE_UNIT[metricMethod - 1]}`,
    },
    {
      logo: "/multi-match/assets/icons/mtn_logo.svg",
      label: t("cfpTable.reducedCo2PerPlot"),
      value: `${Number(reducedCo2 * expectedYield! * plotSize[metricMethod - 1]).toFixed(2)}
            ${REDUCED_CO2_PLOT_MEASURE_UNIT[metricMethod - 1]}`,
    },
  ];

  return (
    <Tooltip
      title={
        <div>
          <p style={{ fontWeight: "bold" }}>{t("cfpTable.carbonBannerTitle") || ""}</p>
          <p>{t("cfpTable.carbonBannerText") || ""}</p>
        </div>
      }
      placement="right"
    >
      <Stack
        gap={1}
        alignItems={"center"}
        sx={{
          paddingX: 3,
          paddingY: 3,
          boxShadow: "0px 0px 9px 0px rgba(108, 116, 133, 0.24);",
          width: "fit-content",
          marginBottom: 3,
          borderRadius: 2,
        }}
      >
        <Typography variant="h5" fontWeight={500}>
          {t("cfpTable.savingTitle")}
        </Typography>
        <Stack direction={"row"} gap={4}>
          {items.map((e, idx) => (
            <SmallerBox key={"smaller_box_" + idx} {...e} isLastItem={items.length - 1 == idx} />
          ))}
        </Stack>
      </Stack>
    </Tooltip>
  );
}
